<section class="toolbar--container">
  <span class="title"
    >{{ "COMMON.NOTIFICATIONS" | translate }}
    <fl-icon
      class="tw:ml-2"
      name="pi-question-circle"
      color="var(--grey-medium)"
      size="24px"
      [escape]="false"
      [pTooltip]="'NOTIFICATIONS.ACTIVE_7_DAYS' | translate"
      data-qa="notifications-active7days-tooltip"
    />
  </span>
  @if (filteredOutNotifications()) {
    <span class="missing-notification-message">
      {{ "NOTIFICATIONS.MISSING_NOTIFICATIONS_1" | translate }}
      @for (entry of filteredOutNotifications()! | keyvalue; track entry.key) {
        @if (entry.value > 0) {
          <span class="event-count" [style.background-color]="NOTIFICATION_PRIORITY_CONFIG[$any(entry.key)].baseColor"
            >{{ entry.value }}
          </span>
        }
      }
      {{ "NOTIFICATIONS.MISSING_NOTIFICATIONS_2" | translate }}
    </span>
  }

  <a
    class="p-button"
    class="notification--button icon--highlight--propagation"
    [flNavRouterLink]="NAV_ROUTES.FLEET.children.EVENTS"
  >
    <fl-icon name="pi-fl-log" size="32px" />
  </a>

  <button
    type="button"
    [class.active]="pinned()"
    class="notification--button icon--highlight--propagation"
    (click)="pinClicked.emit()"
  >
    <fl-icon name="pi-fl-pin" size="32px" />
  </button>
</section>
